import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import ViewUtils from "./../../ViewUtils";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';

const headCells = [
    { id: 'UnitStandardCode', numeric: false, disablePadding: true, label: 'Unit Standard Code' },
    { id: 'UnitStandardDescription', numeric: false, disablePadding: true, label: 'Unit Standard Description' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'AssessmentDate', numeric: false, disablePadding: true, label: 'Assessment Date' },
    { id: 'Assessor', numeric: false, disablePadding: true, label: 'Assessor' },
    { id: 'ModerationDate', numeric: false, disablePadding: true, label: 'Moderation Date' },
    { id: 'Moderator', numeric: false, disablePadding: true, label: 'Moderator' },
    { id: 'Status', numeric: false, disablePadding: true, label: 'Status' }
];



const utils = new ViewUtils();
const toolbarRef = React.createRef();

class ViewUnemployedYouthDevelopmentAchievementUS extends Component {

    state = {
        UnemployedYouthDevelopmentDetails: {
            SkillsProgrammeProgrammeDescription: "",
            SkillsProgrammeProgrammeCode: ""
        },
        messageStyle: "message",
        id: null,
        showTable: true,
        searchParameters: [{ Name: "LearnerUnemployedYouthDevelopmentID", Value: this.props.location.state.LearnerUnemployedYouthDevelopmentID }],
        Learner: this.props.location.state.LearnerID
    };

    toolbarConfig = {
        items: [
            {
                type: "buttonGroup",
                buttons: [
                    { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                ]
            }
        ]
    };


    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.closeView();
        }
    }

    closeView() {
        this.props.history.push({
            pathname: '/LearnerUnemployedYouthDevelopmentAchievements',
            state: {
                learnerID: this.props.location.state.LearnerID,
                learnerNames: this.props.location.state.learnerNames
            }
        });
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {`Learner > Achieved Unemployed Youth Development Unit Standards > ${this.props.location.state.learnerNames}`}
                </p>
                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig} />

                    {this.state.showTable === true && (
                        <EnhancedTable
                            headCells={headCells}
                            dataUrl={`api/sims/LearnerUnemployedYouthDevelopmentAchievement/GetLearnerAchievedUnemployedYouthDevelopmentsUSSearch`}
                            searchParameters={this.state.searchParameters} paged={true} />)}

                </div>
            </ViewContainer>
        );
    }
}

export default withRouter(ViewUnemployedYouthDevelopmentAchievementUS);
